import { OVER_UNDER } from '~/components/BettingInsights/constants';
import { type MarketClassification } from '~/components/BettingInsights/types';

import {
	type BettingSplitsBet,
	type BettingSplitsDrawBet,
	type BettingSplitsTeamBet,
} from '../types';

export function sortBetsBySequence<M extends MarketClassification>(
	bets: BettingSplitsBet[],
	marketClassification: M,
	marketGenericSequence: M extends Omit<MarketClassification, typeof OVER_UNDER>
		? string
		: never,
): [BettingSplitsBet, BettingSplitsDrawBet | undefined, BettingSplitsBet] {
	switch (marketClassification) {
		case OVER_UNDER: {
			const sequence = OVER_UNDER.split('_');
			bets.sort(
				(a, b) =>
					sequence.indexOf(a.betName.toUpperCase()) -
					sequence.indexOf(b.betName.toUpperCase()),
			);

			const [leftBet, rightBet] = bets;

			return [leftBet, undefined, rightBet];
		}
		default: {
			const sequence = marketGenericSequence.split('_');
			const teamBets = bets.filter(
				(bet): bet is BettingSplitsTeamBet => !!bet.teamType,
			);
			const [middleBet] = bets.filter(
				(bet): bet is BettingSplitsDrawBet => !bet.teamType,
			);

			teamBets.sort(
				(a, b) =>
					sequence.indexOf(a.teamType.toUpperCase()) -
					sequence.indexOf(b.teamType.toUpperCase()),
			);

			const [leftBet, rightBet] = teamBets;

			return [leftBet, middleBet, rightBet];
		}
	}
}
